import React from "react";
import { isMobile } from "react-device-detect";

export default function StepBar({ currentStep, steps }) {


  const currentIndex = steps.findIndex(element => element === currentStep);
  const percentFilled = (currentIndex + 1) * (100 / steps.length);


  return (
    <div className="StepBar">
      { isMobile ?
              <div className="active" style={{ width: `${percentFilled}%` }} />
          :
          <>
          {steps.map((step, i) => (
              <div className={`step-container`} key={i}>
                  <span className={`${i == currentIndex ? 'step-active' : i < currentIndex ? 'step-end':'step'}`}/>
                      {<span className="step-title"> {step}</span>}
                </div>
          ))
          }</>
        }
    </div>
  );
}
